export function extract_num_id_from_id(id: string) {
	const numId = id?.split('-').reverse()[0];

	if (numId) {
		return numId;
	}
	return '';
}
